<template>
    <div class="extra-all">
        <div class="container">
            <h1>Optional Extras</h1>

            <div class="card">
                <b-table striped :items="extras" :fields="fields">
                    <template slot="actions" scope="row">
                        <div class="btn-group ml-auto">
                            <b-button type="button" class="mr-2" v-on:click="edit(row.item)">
                                Edit
                            </b-button>

                            <b-button type="button" class="mr-2" variant="warning" v-on:click="duplicate(row.item)">
                                Duplicate
                            </b-button>

                            <b-button type="button" class="mr-2" variant="danger" v-on:click="del(row.item)">
                                Delete
                            </b-button>
                        </div>
                    </template>
                </b-table>
            </div>

            <b-button type="button" size="lg" class="ml-auto mr-auto mt-4 d-block" variant="success" v-on:click="create()">Create extra</b-button>
        </div>

        <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </div>
</template>

<script>
  import Simplert from 'vue2-simplert'

  export default {
    name: 'extraAll',
    props: ['fb'],
    components: {
      Simplert
    },
    firebase () {
      return {
        extras: this.fb.database().ref('extras').orderByChild('published').equalTo(true)
      }
    },
    data () {
      return {
        editingKey: null,
        editingImagesKey: null,
        sortBy: 'name',
        sortDesc: false,
        fields: [
          {
            key: 'name',
            label: 'Name',
            sortable: true
          },
          {
            key: 'actions',
            sortable: false
          }
        ]
      }
    },
    methods: {
      create () {
        let extra = this.$firebaseRefs.extras.push({
          published: false,
          costPrice: 0,
          ssp: 0,
          families: [],
          colours: [],
          priceOverrides: []
        })
        this.$router.push('/extra/' + extra.key)
      },
      edit (extra) {
        this.$router.push('/extra/' + extra['.key'])
      },
      duplicate (extra) {
        delete extra['.key']
        let vm = this
        this.$refs.simplert.openSimplert({
          title: 'Are you sure?',
          message: 'Are you sure you want to duplicate ' + extra.name + '?',
          type: 'info',
          useConfirmBtn: true,
          onConfirm () {
            extra.name = extra.name + ' (copy)'
            extra.publised = false
            let newExtra = vm.$firebaseRefs.extras.push(extra)
            vm.$router.push('/extra/' + newExtra.key)
          }
        })
      },
      del (extra) {
        let vm = this
        this.$refs.simplert.openSimplert({
          title: 'Are you sure?',
          message: 'Are you sure you want to remove this optional extra? Its association with all products will be removed',
          type: 'info',
          useConfirmBtn: true,
          onConfirm () {
            vm.$firebaseRefs.extras.child(extra['.key']).remove()
            vm.$refs.simplert.openSimplert({
              title: 'Deleted',
              type: 'info',
              message: 'The extra and its association with all products has been deleted'
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ExtraAll.vue